import React from 'react';
import { useSupportTranslation } from '../../i18n/hooks/useSupportTranslation';
import SupportHeader from './header/SupportHeader';
import SupportTiers from './tiers/SupportTiers';
import CustomSupportCTA from './cta/CustomSupportCTA';

const SupportSection = () => {
  const { getSupportTranslation } = useSupportTranslation();
  const translation = getSupportTranslation();

  return (
    <div id="support" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SupportHeader 
          title={translation.title}
          subtitle={translation.subtitle}
        />

        <div className="mt-16">
          <SupportTiers plans={[
            { ...translation.plans.basic, featured: false },
            { ...translation.plans.premium, featured: true },
            { ...translation.plans.platinum, featured: false }
          ]} />
        </div>

        <div className="mt-16">
          <CustomSupportCTA 
            text={translation.customSupport.text}
            buttonText={translation.customSupport.buttonText}
          />
        </div>
      </div>
    </div>
  );
};

export default SupportSection;